import { api } from "@/api";

export const deleteSportNew = async (id: number): Promise<void> => {
  await api.client.delete(`/sports-new/${id}`);
};
